import React, { Component } from 'react';
import Dico from '../../helpers/Dico'
import SliderCriteria from '../std/SliderCriteria';

class MileagesSelector extends Component {

    getMessage(i18nKey) { return Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, i18nKey) }

    handleMileageChange = value => {
        value *= 1.0;
        this.props.onChange(value, this.props.settings);
    }

    render() {
        const mileagesFiltered = this.props.contextCriteria.mileagesFiltered;
        const i18nKeyMileage = this.props.context.countryCode === 'GB' ? 'calculatorPage.criteria.value.mileage.GB' : 'calculatorPage.criteria.value.mileage';
        return (
            mileagesFiltered != null
            && ((mileagesFiltered.values != null && mileagesFiltered.values.length > 0)
            || (mileagesFiltered.min != null && mileagesFiltered.max != null))
            && <div className="row shadow-sm rounded m-auto">
                <h5 className="text-secondary">{this.getMessage('calculatorPage.criteria.mileage.annual')}</h5>
                <SliderCriteria
                    value={this.props.parameters.annualMileage}
                    min={mileagesFiltered.min}
                    max={mileagesFiltered.max}
                    step={mileagesFiltered.step}
                    values={mileagesFiltered.values}
                    i18nKey={i18nKeyMileage}
                    i18nArgType='integer'
                    onChange={this.handleMileageChange}
                    contextMin={this.props.contextCriteria.kmanMinSvc}
                    contextMax={this.props.contextCriteria.kmanMaxSvc}
                />
            </div>
        );
    }
}
export default (MileagesSelector)
